export default __webpack_public_path__ + "/dist/images/8741525.71e761f013f784f1e3bd172a201a474d.png";